/**
 * A text field that scrolls (a long JSON param) keeps its scroll: reaching its end does not scroll
 * the page. Only real vertical scrollers get this: on a wrapper that only scrolls sideways, such as
 * a table's, Chrome would stop the wheel there and the page could not be scrolled over it at all.
 * The plugin catalog and the company list set it on themselves.
 */
export const KEEP_SCROLL_INSIDE = { '& textarea': { overscrollBehavior: 'contain' } } as const;
